import { CopyText, CopyTextProps } from "@/components/CopyText"
import cn from "@/utils/cn"
import { ComponentPropsWithoutRef, ReactNode } from "react"

type LabeledTextPropsBase = {
  label: string
  value?: ReactNode
} & ComponentPropsWithoutRef<"div">

type LabeledTextPropsWithCopy = LabeledTextPropsBase & {
  copy?: true
  showCopyOnlyOnHover?: boolean
}

type LabeledTextPropsWithoutCopy = LabeledTextPropsBase & {
  copy: false
}

type LabeledTextProps = LabeledTextPropsWithCopy | LabeledTextPropsWithoutCopy

const LabeledText = (props: LabeledTextProps) => {
  const { label, value, className, ...otherProps } = props
  const hasValue = value !== undefined && value !== null && value !== ""

  let copyBehavior: CopyTextProps["copyButtonBehavior"]
  switch (true) {
    case props.copy !== false && props.showCopyOnlyOnHover !== false:
      copyBehavior = "hover"
      break
    case props.copy !== false && props.showCopyOnlyOnHover === false:
      copyBehavior = "always"
      break
    default:
      copyBehavior = "never"
      break
  }

  return (
    <div className={cn("gap-0.25 flex flex-col", className)} {...otherProps}>
      <p className="mb-1 text-[16px] font-bold tracking-wide">{label}</p>
      <div className="group flex items-center gap-1">
        {hasValue ? (
          <CopyText
            text={value.toString()}
            label={label}
            copyButtonBehavior={copyBehavior}
          >
            <p className="wrap-break-word text-[15px] tracking-wide">{value}</p>
          </CopyText>
        ) : (
          <p className="wrap-break-word text-[15px] tracking-wide">-</p>
        )}
      </div>
    </div>
  )
}

export default LabeledText
